__turbopack_context__.v({
  "fadeIn": "AkKL0W_fadeIn",
  "tab": "AkKL0W_tab",
  "tabPanel": "AkKL0W_tabPanel",
  "tabs": "AkKL0W_tabs",
  "tabsContent": "AkKL0W_tabsContent",
  "tabsList": "AkKL0W_tabsList",
});
